const heroVideos = document.querySelectorAll('[data-hero]');

heroVideos.forEach((hero) => {
  const video = hero.querySelector('video');
  const toggle = hero.querySelector('[data-hero-video-toggle]');

  if (!video || !toggle) return;

  toggle.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      toggle.classList.remove('is-paused');
      toggle.setAttribute('aria-label', 'Video pausieren');
      return;
    }

    video.pause();
    toggle.classList.add('is-paused');
    toggle.setAttribute('aria-label', 'Video abspielen');
  });
});
